import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/pro-regular-svg-icons";
import AgentMarkdown from "./AgentMarkdown";
import AgentToolChips from "./AgentToolChips";
import AgentArtifacts from "./AgentArtifacts";
import LoadingSpinner from "../LoadingSpinner";
import { brand } from "../../theme/gitoColors";

export default function AgentMessageList({
    messages,
    streaming,
    showColdStart,
    loading,
    sessionId,
    getAccessToken,
}) {
    const { t } = useTranslation();
    const listRef = useRef(null);

    useEffect(() => {
        const list = listRef.current;
        if (!list) {
            return;
        }
        list.scrollTop = list.scrollHeight;
    }, [messages, streaming, showColdStart]);

    if (loading) {
        return (
            <div className="flex min-h-0 flex-1 items-center justify-center p-6">
                <LoadingSpinner text={t("agent.loadingChat")} delayMs={0} />
            </div>
        );
    }

    if (messages.length === 0 && !streaming) {
        return (
            <div className="flex min-h-0 flex-1 items-center justify-center p-4 md:p-6">
                <div className="empty-state max-w-md px-6 py-8 text-center md:px-8 md:py-10">
                    <FontAwesomeIcon icon={faComments} className="mb-3 text-xl text-primary-500" />
                    <p className="text-sm font-bold text-mute-900">{t("agent.askAgge")}</p>
                    <p className="mt-2 text-sm text-mute-600">
                        {t("agent.subtitle")}
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div ref={listRef} className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 py-3 md:px-6 md:py-4">
            <div className="flex flex-col gap-3 md:gap-4">
                {messages.map((message) =>
                    message.role === "user" ? (
                        <div key={message.id} className="flex justify-end">
                            <div
                                className="max-w-[88%] rounded-2xl px-3 py-2 text-sm whitespace-pre-wrap break-words md:max-w-[75%] md:px-4"
                                style={{ backgroundColor: brand.darkBlue, color: brand.white }}
                            >
                                {message.text}
                            </div>
                        </div>
                    ) : (
                        <div key={message.id} className="flex justify-start">
                            <div className="w-full min-w-0 overflow-x-auto rounded-2xl border border-mute-200 bg-mute-25 px-3 py-3 md:px-4">
                                <p className="mb-2 text-xs font-bold uppercase tracking-wide text-primary-700">
                                    {t("nav.agge")}
                                </p>
                                <AgentMarkdown text={message.text} />
                                <AgentToolChips tools={message.tools} />
                                <AgentArtifacts
                                    artifacts={message.artifacts}
                                    sessionId={sessionId}
                                    getAccessToken={getAccessToken}
                                />
                            </div>
                        </div>
                    )
                )}
                {showColdStart ? (
                    <p className="text-sm text-mute-500">
                        {t("agent.coldStart")}
                    </p>
                ) : null}
            </div>
        </div>
    );
}
